import classNames from 'classnames';
import React, { useMemo } from 'react';

interface CheckboxProps {
  checked: boolean;
  intermediate?: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  children?: unknown;
  falseValue?: unknown;
  trueValue?: unknown;
  variant?: 'v2' | 'v3';
  useSwqStyle?: boolean;
}

const Checkbox = ({
  checked,
  onChange,
  disabled,
  children,
  falseValue,
  trueValue,
  variant,
  intermediate,
  useSwqStyle,
}: CheckboxProps) => {
  const id = useMemo(() => Math.floor(Math.random() * 1000000).toString(), []);

  const onClick = (e) => {
    if (disabled) return;
    let value = e.target.checked;

    if (value && trueValue !== undefined) {
      value = trueValue;
    }

    if (!value && falseValue !== undefined) {
      value = falseValue;
    }

    onChange(value);
  };

  return (
    <div
      className={classNames('worx-check-radio', {
        'worx-check-radio--no-label': !children,
        'worx-check-radio--v2': variant === 'v2',
        'worx-check-radio--intermediate': intermediate,
        'swq-worx-check-radio': useSwqStyle,
      })}
    >
      <input
        id={id}
        className={variant === 'v3' ? 'margin-top-4' : 'form-control'}
        type="checkbox"
        checked={trueValue ? trueValue === checked : checked || false}
        onChange={onClick}
        disabled={disabled}
      />
      <label className={variant === 'v3' ? 'margin-left-14' : 'control-label'} htmlFor={id}>
        {!!children && <span className="label-text">{children}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
